module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('grid-x', {
    attrs: {
      "col": "1fr 1fr",
      "row": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "redirect-strings"
  }, [_c('h1', [_vm._v("Redirect Strings")]), _vm._v(" "), _c('div', {
    staticClass: "redirect-input"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectString.from),
      expression: "newRedirectString.from"
    }],
    attrs: {
      "type": "text",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.newRedirectString.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectString, "from", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectString.to),
      expression: "newRedirectString.to"
    }],
    attrs: {
      "type": "text",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.newRedirectString.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectString, "to", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": _vm.createRedirectString
    }
  }, [_vm._v("Create Redirect String")])]), _vm._v(" "), _c('div', {
    staticClass: "flex redirect"
  }, [_c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("From")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("To")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-1"
  })]), _vm._v(" "), _vm._l((_vm.redirectStrings), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items redirect flex flex-space-between center-flex-y"
    }, [_c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.from))]), _vm._v(" "), _c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.to))]), _vm._v(" "), _c('span', {
      staticClass: "flex-1"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeRedirectString(item)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "redirect-regex"
  }, [_c('h1', [_vm._v("Redirect Regex")]), _vm._v(" "), _c('div', {
    staticClass: "redirect-input"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectRegex.from),
      expression: "newRedirectRegex.from"
    }],
    attrs: {
      "type": "text",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.newRedirectRegex.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectRegex, "from", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newRedirectRegex.to),
      expression: "newRedirectRegex.to"
    }],
    attrs: {
      "type": "text",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.newRedirectRegex.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newRedirectRegex, "to", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "20px"
    },
    on: {
      "click": _vm.createRedirectRegex
    }
  }, [_vm._v("Create Redirect Regex")])]), _vm._v(" "), _c('div', {
    staticClass: "flex redirect"
  }, [_c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("From")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-3"
  }, [_c('b', [_vm._v("To")])]), _vm._v(" "), _c('span', {
    staticClass: "flex-1"
  })]), _vm._v(" "), _vm._l((_vm.redirectRegex), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items redirect flex center-flex-y"
    }, [_c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.from))]), _vm._v(" "), _c('span', {
      staticClass: "flex-3"
    }, [_vm._v(_vm._s(item.to))]), _vm._v(" "), _c('span', {
      staticClass: "flex-1"
    }, [_c('button', {
      on: {
        "click": function($event) {
          _vm.removeRedirectRegex(item)
        }
      }
    }, [_vm._v("Remove")])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac467262"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/redirects.vue
// module id = 678
// module chunks = 1